module.exports = __webpack_public_path__ + "static/partner-sophos-0b04d3084cebe49fec5004cc62f1ffc4.png";